import React, { useCallback } from 'react'
import { AbstractBulkUpload } from '../../components/AbstractBulkFileUpload'
import { useLazyApiData, useStores } from '../../data/store'

const { REACT_APP_ENDPOINT = '' } = window?._env_

export const BulkPackageToMidApproval = () => {
  const { bulkProcessApprovals } = useStores((store) => ({
    bulkProcessApprovals: store.packageToMId.bulkProcessApprovals,
  }))

  const [lazyBulkProcessApprovals, bulkProcessApprovalsHandler] = useLazyApiData(bulkProcessApprovals)

  const [selctedFileInfo, setSelectedFileInfo] = React.useState({
    fileName: undefined,
    data: [],
    keys: [],
  })

  const FILE_COLLUMNS = ['id', 'approvalType', 'approvalStatus']
  const respCollumns = ['id', 'type', 'approvalStatus', 'status', 'message']

  const processPackagesToMidFile = useCallback(() => {
    lazyBulkProcessApprovals(
      selctedFileInfo?.data?.map((item) => ({
        id: item?.id,
        type: item?.approvalType,
        status: item?.approvalStatus ?? false,
      })),
    )
  }, [lazyBulkProcessApprovals, selctedFileInfo.data])
  console.log(selctedFileInfo.data)

  return (
    <AbstractBulkUpload
      apiHandler={bulkProcessApprovalsHandler}
      selctedFileInfo={selctedFileInfo}
      innerCompTitle={'Please upload mid to package approval file'}
      innnerCompSubtitle={'Browse your mid to package approval file'}
      setSelectedFileInfo={setSelectedFileInfo}
      expectedFileCollumns={FILE_COLLUMNS}
      sampleFilePath={`${REACT_APP_ENDPOINT}/sample_bulk_package_to_mid_approval_file.xlsx`}
      onConfirmButtonPress={processPackagesToMidFile}
      respCollumns={respCollumns}
    />
  )
}
